export const BufferBridge = Buffer;
